var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExams(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.412,
    height: 22.413,
    viewBox: "1222.75 438.75 22.412 22.413",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 805"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Path 859"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1240.894 461.163h-17.077c-.589 0-1.066-.478-1.067-1.067v-20.279c0-.589.478-1.066 1.067-1.067h17.077c.589 0 1.067.478 1.067 1.067v4.803a.534.534 0 1 1-1.067 0v-4.803h-17.077v20.279h17.077v-8.539a.534.534 0 1 1 1.067 0v8.539c0 .589-.478 1.066-1.067 1.067Z",
    fill: "#010038",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1240.894 461.163h-17.077c-.589 0-1.066-.478-1.067-1.067v-20.279c0-.589.478-1.066 1.067-1.067h17.077c.589 0 1.067.478 1.067 1.067v4.803a.534.534 0 1 1-1.067 0v-4.803h-17.077v20.279h17.077v-8.539a.534.534 0 1 1 1.067 0v8.539c0 .589-.478 1.066-1.067 1.067Z",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 0.5,
    stroke: "#f5f5f5",
    fill: "transparent"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Path 860"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1240.442 442.96h-16.143a.475.475 0 1 1 0-.95h16.143a.475.475 0 1 1 0 .95Z",
    fill: "#010038",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1240.442 442.96h-16.143a.475.475 0 1 1 0-.95h16.143a.475.475 0 1 1 0 .95Z",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 0.5,
    stroke: "#f5f5f5",
    fill: "transparent"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1226 441.4a.5.5 0 1 1 0 .1z",
    fill: "#010038",
    fillRule: "evenodd",
    "data-name": "Ellipse 57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1228 441.4a.5.5 0 1 1 0 .1z",
    fill: "#010038",
    fillRule: "evenodd",
    "data-name": "Ellipse 58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1230 441.4a.5.5 0 1 1 0 .1z",
    fill: "#010038",
    fillRule: "evenodd",
    "data-name": "Ellipse 59"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Path 861"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1228.086 448.356h-2.134c-.59-.001-1.067-.479-1.067-1.068v-2.134c0-.59.478-1.067 1.067-1.068h2.134c.59.001 1.067.479 1.068 1.068v2.134c0 .59-.478 1.067-1.068 1.068Zm-2.134-3.202v2.134h2.135v-2.134h-2.135Zm11.206.533h-6.403a.534.534 0 0 1 0-1.067h6.403a.534.534 0 0 1 0 1.067Zm0 2.135h-6.403a.534.534 0 0 1 0-1.067h6.403a.534.534 0 0 1 0 1.067Zm-9.072 5.87h-2.134c-.59 0-1.067-.478-1.067-1.067v-2.135c0-.59.478-1.067 1.067-1.067h2.134c.59 0 1.067.478 1.068 1.067v2.135c0 .589-.478 1.066-1.068 1.067Zm-2.134-3.202v2.135h2.135v-2.135h-2.135Zm10.139.534h-5.336a.534.534 0 1 1 0-1.068h5.336a.534.534 0 0 1 0 1.068Zm-1.067 2.134h-4.27a.534.534 0 0 1 0-1.067h4.27a.534.534 0 1 1 0 1.067Zm-6.938 5.87h-2.134c-.59 0-1.067-.478-1.067-1.067v-2.134c0-.59.478-1.067 1.067-1.068h2.134c.59 0 1.067.478 1.068 1.068v2.134c0 .59-.478 1.067-1.068 1.067Zm-2.134-3.201v2.134h2.135v-2.134h-2.135Zm7.47.533h-2.667a.534.534 0 1 1 0-1.067h2.668a.534.534 0 0 1 0 1.067Zm2.669 2.135h-5.336a.534.534 0 0 1 0-1.068h5.336a.534.534 0 0 1 0 1.068Z",
    fill: "#010038",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1228.086 448.356h-2.134c-.59-.001-1.067-.479-1.067-1.068v-2.134c0-.59.478-1.067 1.067-1.068h2.134c.59.001 1.067.479 1.068 1.068v2.134c0 .59-.478 1.067-1.068 1.068Zm-2.134-3.202v2.134h2.135v-2.134h-2.135Zm11.206.533h-6.403a.534.534 0 0 1 0-1.067h6.403a.534.534 0 0 1 0 1.067Zm0 2.135h-6.403a.534.534 0 0 1 0-1.067h6.403a.534.534 0 0 1 0 1.067Zm-9.072 5.87h-2.134c-.59 0-1.067-.478-1.067-1.067v-2.135c0-.59.478-1.067 1.067-1.067h2.134c.59 0 1.067.478 1.068 1.067v2.135c0 .589-.478 1.066-1.068 1.067Zm-2.134-3.202v2.135h2.135v-2.135h-2.135Zm10.139.534h-5.336a.534.534 0 1 1 0-1.068h5.336a.534.534 0 0 1 0 1.068Zm-1.067 2.134h-4.27a.534.534 0 0 1 0-1.067h4.27a.534.534 0 1 1 0 1.067Zm-6.938 5.87h-2.134c-.59 0-1.067-.478-1.067-1.067v-2.134c0-.59.478-1.067 1.067-1.068h2.134c.59 0 1.067.478 1.068 1.068v2.134c0 .59-.478 1.067-1.068 1.067Zm-2.134-3.201v2.134h2.135v-2.134h-2.135Zm7.47.533h-2.667a.534.534 0 1 1 0-1.067h2.668a.534.534 0 0 1 0 1.067Zm2.669 2.135h-5.336a.534.534 0 0 1 0-1.068h5.336a.534.534 0 0 1 0 1.068Z",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 0.5,
    stroke: "#f5f5f5",
    fill: "transparent"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Path 862"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1236.121 458.13a.534.534 0 0 1-.513-.39l-.615-2.18a.534.534 0 0 1 .048-.405l6.26-11.173a1.067 1.067 0 0 1 1.453-.41l1.863 1.044c.514.288.697.939.409 1.453l-6.26 11.173a.534.534 0 0 1-.32.253l-2.18.614a.53.53 0 0 1-.145.02Zm2.18-1.149Zm-2.22-1.497.41 1.453 1.452-.41 6.152-10.98-1.863-1.043-6.151 10.98Z",
    fill: "#010038",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1236.121 458.13a.534.534 0 0 1-.513-.39l-.615-2.18a.534.534 0 0 1 .048-.405l6.26-11.173a1.067 1.067 0 0 1 1.453-.41l1.863 1.044c.514.288.697.939.409 1.453l-6.26 11.173a.534.534 0 0 1-.32.253l-2.18.614a.53.53 0 0 1-.145.02Zm2.18-1.149Zm-2.22-1.497.41 1.453 1.452-.41 6.152-10.98-1.863-1.043-6.151 10.98Z",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 0.5,
    stroke: "#f5f5f5",
    fill: "transparent"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1242.89 448.819a.365.365 0 0 1-.178-.047l-1.914-1.072a.366.366 0 0 1 .357-.639l1.915 1.073a.366.366 0 0 1-.18.685Zm-3.038 5.424a.365.365 0 0 1-.179-.046l-1.914-1.073a.366.366 0 0 1 .357-.638l1.915 1.073a.366.366 0 0 1-.18.685Z",
    fill: "#010038",
    fillRule: "evenodd",
    "data-name": "Path 863"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExams);
export default __webpack_public_path__ + "static/media/exams.34e2baba100b61cdfbdc2bae2756f293.svg";
export { ForwardRef as ReactComponent };